export const routes = {
  callback: "/callback",
  projects: "/projects",
  premisesByProject: "/premises/:projectId",
  premises: "/",
  changes: "/changes",
  newPremise: "/new-premise",
  draftPremise: "/new-premise/:requestId/:source?",
  drafts: "/drafts",
  tasks: "/tasks",
  claim: "/claim",
  changeRequest: "/change-request",
  draftChangeRequest: "/change-request/:requestId",
  reports: "/reports",
  removeSupply: "/remove-supply",
  publicRemoveSupply: "/account-holder-request/:code",
  publicRemoveSupplySuccess: "/success",
  //TODO: update the url based on kraken's feedback
  draftRemoveSupply: "/remove-supply/:requestId",
  publicEICForm: "/customer-account-form",
};
